package kz.dentalcrm.app.screens.protocols.edit

import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.error_message
import dentalcrm.composeapp.generated.resources.snackbar_treatment_added
import dentalcrm.composeapp.generated.resources.snackbar_treatment_deleted
import dentalcrm.composeapp.generated.resources.snackbar_treatment_edited
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.core.utils.Result
import kz.dentalcrm.app.data.network.response_model.protocol_templates.ProtocolTemplate
import kz.dentalcrm.app.domain.TreatmentRepository
import kz.dentalcrm.app.screens.protocols.edit.mvi.EditProtocolViewEvent
import kz.dentalcrm.app.screens.protocols.edit.mvi.EditProtocolViewSideEffect
import kz.dentalcrm.app.screens.protocols.edit.mvi.EditProtocolViewState
import kz.dentalcrm.app.theme.SnackbarController
import kz.dentalcrm.app.theme.SnackbarEvent
import org.jetbrains.compose.resources.getString
import org.koin.core.component.inject

class EditProtocolViewModel :
    BaseStateViewModel<EditProtocolViewEvent, EditProtocolViewState, EditProtocolViewSideEffect>() {

    private val treatmentRepository: TreatmentRepository by inject()

    private val _isLoading = MutableStateFlow(false)
    val loading: StateFlow<Boolean> = _isLoading

    private fun addDiagnosis(name: String, code: String, id: Int) {
        setState {
            copy(
                screenState = EditProtocolViewState.ScreenState.Editing
            )
        }
        launch(Dispatchers.Default) {
            when (val result = treatmentRepository.addEditTreatment(
                name = name,
                code = code,
                id = id,
            )) {
                is Result.Success -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.snackbar_treatment_edited), SnackbarEvent.SnackbarType.Green))
                    setState {
                        copy(
                            screenState = EditProtocolViewState.ScreenState.Edited
                        )
                    }
                }

                is Result.Error -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState {
                        copy(
                            screenState = EditProtocolViewState.ScreenState.Error(
                                error = result.message
                                    ?: "Неизвестная ошибка (Проверьте введенные данные)"
                            )
                        )
                    }
                }

                else -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState {
                        copy(
                            screenState = EditProtocolViewState.ScreenState.Error(
                                error = "Неизвестная ошибка (Проверьте введенные данные)"
                            )
                        )
                    }
                }
            }
        }
    }

    private fun deleteDiagnosis(treatment: ProtocolTemplate) {
        setState {
            copy(
                screenState = EditProtocolViewState.ScreenState.Editing
            )
        }
        launch(Dispatchers.Default) {
            when (val result = treatmentRepository.deleteTreatment(
                id = treatment.id
            )) {
                is Result.Success -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.snackbar_treatment_deleted), SnackbarEvent.SnackbarType.Green))
                    setState {
                        copy(
                            screenState = EditProtocolViewState.ScreenState.Deleted
                        )
                    }
                }

                is Result.Error -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState {
                        copy(
                            screenState = EditProtocolViewState.ScreenState.Error(
                                error = result.message
                                    ?: "Неизвестная ошибка (Проверьте введенные данные)"
                            )
                        )
                    }
                }

                else -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState {
                        copy(
                            screenState = EditProtocolViewState.ScreenState.Error(
                                error = "Неизвестная ошибка (Проверьте введенные данные)"
                            )
                        )
                    }
                }
            }
        }
    }

    override fun setInitialState() = EditProtocolViewState()

    override fun handleEvents(event: EditProtocolViewEvent) {
        when (event) {
            is EditProtocolViewEvent.EditProtocol -> {
                addDiagnosis(name = event.naming, code = event.code, id = event.id)
            }

            is EditProtocolViewEvent.DeleteProtocol -> {
                deleteDiagnosis(treatment = event.treatment)
            }
            EditProtocolViewEvent.Reset -> setState { copy(screenState = EditProtocolViewState.ScreenState.Idle) }
        }
    }

    override fun onCleared() {
        setState { EditProtocolViewState() }
        _isLoading.value = false
    }
}